import { gql } from "@apollo/client"

export const TodoTasksTaskFragment = gql`
  fragment TodoTasksTaskDetails on TodoTasksTask {
    category
    checkAvailableFor
    id
    name
    parties
    position
    state
    visibleTo
    completedAt
    completedBy {
      name
      isOysterStaff
    }
  }
`
